import React, { useEffect, useState, useCallback } from 'react'
import { supabase } from '../supabaseClient'

const POLL_MS = 60000

export default function AdminNotificationBar({ profile }) {
  const [notifs,   setNotifs]   = useState([])
  const [broken,   setBroken]   = useState([])
  const [open,     setOpen]     = useState(false)

  const load = useCallback(async () => {
    const [{ data: n }, healthRes] = await Promise.all([
      supabase.from('notifications').select('*').eq('user_id', profile.id).eq('is_read', false).order('created_at', { ascending: false }).limit(20),
      fetch('/api/health-check').then(r => r.json()).catch(() => null),
    ])
    setNotifs(n || [])
    setBroken((healthRes?.services || []).filter(s => s.status === 'error'))
  }, [profile.id])

  useEffect(() => {
    load()
    const id = setInterval(load, POLL_MS)
    return () => clearInterval(id)
  }, [load])

  async function dismiss(id) {
    setNotifs(prev => prev.filter(n => n.id !== id))
    await supabase.from('notifications').update({ is_read: true }).eq('id', id)
  }

  async function dismissAll() {
    const ids = notifs.map(n => n.id)
    setNotifs([])
    if (ids.length) await supabase.from('notifications').update({ is_read: true }).in('id', ids)
  }

  const total   = notifs.length + broken.length
  const allClear = total === 0

  return (
    <div style={{ marginBottom: '16px' }}>
      <button onClick={() => !allClear && setOpen(o => !o)} style={{
        width: '100%', display: 'flex', alignItems: 'center', gap: '10px',
        padding: '11px 16px', borderRadius: '12px',
        border: allClear ? '0.5px solid rgba(16,185,129,0.25)' : '0.5px solid rgba(239,68,68,0.3)',
        background: allClear ? 'rgba(16,185,129,0.06)' : 'rgba(239,68,68,0.08)',
        cursor: allClear ? 'default' : 'pointer', fontFamily: 'inherit', textAlign: 'left',
      }}>
        <span style={{ fontSize: '18px' }}>{allClear ? '✅' : '🔔'}</span>
        <span style={{ flex: 1, fontSize: '13px', fontWeight: 700, color: allClear ? '#34d399' : '#f87171' }}>
          {allClear ? 'All systems normal — nothing needs your attention' : `${total} thing${total !== 1 ? 's' : ''} need${total === 1 ? 's' : ''} your attention`}
        </span>
        {!allClear && <span style={{ fontSize: '11px', color: 'rgba(var(--fg-rgb),var(--a40))' }}>{open ? '▲ Hide' : '▼ Show'}</span>}
      </button>

      {open && (
        <div style={{ marginTop: '8px', display: 'grid', gap: '6px' }}>
          {broken.map(s => (
            <div key={s.name} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', background: 'rgba(239,68,68,0.06)', border: '0.5px solid rgba(239,68,68,0.2)', borderRadius: '10px' }}>
              <span style={{ fontSize: '16px' }}>🩺</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '12px', fontWeight: 700, color: 'rgba(var(--fg-rgb),var(--a80))' }}>{s.name} is broken</div>
                <div style={{ fontSize: '11px', color: 'rgba(var(--fg-rgb),var(--a35))', marginTop: '1px' }}>{s.message}</div>
              </div>
              <span style={{ fontSize: '10px', color: 'rgba(var(--fg-rgb),var(--a30))', flexShrink: 0 }}>System Health</span>
            </div>
          ))}
          {notifs.map(n => (
            <div key={n.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px', background: 'rgba(244,163,53,0.06)', border: '0.5px solid rgba(244,163,53,0.2)', borderRadius: '10px' }}>
              <span style={{ fontSize: '16px' }}>{n.type === 'no_show' ? '⚠️' : '🔔'}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '12px', fontWeight: 700, color: 'rgba(var(--fg-rgb),var(--a80))' }}>{n.title}</div>
                <div style={{ fontSize: '11px', color: 'rgba(var(--fg-rgb),var(--a35))', marginTop: '1px' }}>{n.message}</div>
              </div>
              <button onClick={() => dismiss(n.id)} style={{ fontSize: '10px', fontWeight: 700, padding: '4px 10px', borderRadius: '7px', background: 'rgba(var(--fg-rgb),0.06)', color: 'rgba(var(--fg-rgb),var(--a50))', border: 'none', cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0 }}>Dismiss</button>
            </div>
          ))}
          {notifs.length > 0 && (
            <button onClick={dismissAll} style={{ justifySelf: 'start', fontSize: '11px', color: 'rgba(var(--fg-rgb),var(--a35))', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', padding: '4px 2px' }}>
              Dismiss all notifications
            </button>
          )}
        </div>
      )}
    </div>
  )
}
